import css from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import Image from '@/components/UI/Image';

/**
 * 2022-01-22 k.w 自定义轮滑组件(卡片组件之No.3)
 */

const defaultStyle = {
    theme: 'white',
    list: {
        imgWidth: 2.6,
        imgHeight: 3.2,
        listGap: 0.25, // list之间间隔
        listWidth: 2.6,
        listHeight: 'auto',
    },
    textStyle: {
        marginTop: '.16rem',
        textAlign: 'center',
        lineHeight: '.22rem',
        fontSize: '.14rem',
        color: 'rgb(145,145,145)',
        fontClass: 'font-family-semibold',
    },
};

const defaultData = [
    { img: '/img/card-slide-1.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-2.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-3.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-4.png', desc: 'Power your home for days' },
];

export default function CardSliderModule({ cssStyle = defaultStyle, data = defaultData }: any) {
    const styles = {
        theme: cssStyle.theme ?? defaultStyle.theme,
        list: { ...defaultStyle.list, ...cssStyle?.list },
        textStyle: { ...defaultStyle.textStyle, ...cssStyle?.textStyle },
        webpUrl: cssStyle?.webpUrl,
    };
    const { EFPic } = createEFPic(styles?.webpUrl);
    const { theme, list, textStyle } = styles;
    // 背景主题
    const isWhiteTheme = theme === 'white' || theme === '#fff' || theme === '#ffffff' || theme === 'transparent';

    // 触屏拖拽mobile
    let originX = 0,
        startX = 0;
    const touchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0].clientX;
    };
    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0].clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= -e.currentTarget.offsetWidth + window.innerWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    return (
        <div className={`${css.cardSliderModule} cardSliderModule`} style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
            <div className="cardSliderWrapper">
                <div
                    className="sliderContent"
                    style={{
                        height: data.some((item: any) => !!item.desc === true) ? `${list.imgHeight + 0.38}rem` : `${list.imgHeight}rem`,
                    }}
                >
                    <ul className="listBox" onTouchMove={touchMove} onTouchStart={touchStart}>
                        {data.map((item: any, k: number) => (
                            <li
                                className="list"
                                key={k}
                                style={{
                                    marginLeft: k === 0 ? 0 : `${parseFloat(list.listGap)}rem`,
                                    width: `${list.listWidth}rem`,
                                    height: `${list.listHeight}rem`,
                                }}
                            >
                                <div
                                    className="signFullImgsBox"
                                    style={{
                                        width: `${list.imgWidth}rem`,
                                        height: `${list.imgHeight}rem`,
                                    }}
                                >
                                    {Array.isArray(item.img) ? (
                                        <EFPic name={item.img} alt={item.alt || item.desc} />
                                    ) : (
                                        <Image src={item.img} layout="fill" alt={item.alt || item.desc} />
                                    )}
                                </div>
                                <p
                                    className="descText font-family-semibold"
                                    style={{
                                        ...textStyle,
                                        ...{
                                            display: item.desc ? 'block' : 'none',
                                        },
                                    }}
                                >
                                    {item.desc}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
